<template>
  <div class="toolsBar"> 
      <div class='myDrive' >My Drive</div>
      <div class='itemRight'>
        <md-icon class='inputN_icon'>cloud_upload</md-icon>
        <md-icon class='inputN_icon'>create_new_folder</md-icon>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ToolsBar',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .toolsBar{
    background-color: #EFEFEF;
    max-height: 81px;
    border: 0px;
    border-style: solid;
    padding: 24px 85px 24px 85px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  
.myDrive{
  text-align: center;
  align-self: center;
  font-size: 24px;
  font-style: "Helvetica Neue" bold;
  line-height: 24px;
}
 .inputN_icon{
   margin: 5px;
 }
</style>
